const pre = '/home/';

export default {
    path: '/home',
    title: '控制台',
    header: '',
    icon: 'md-speedometer',
    children: [
        {
            path: `${pre}console`,
            title: '数据总览'
        },
        {
            path: `${pre}nfr`,
            title: 'NFR 概览'
        },
    ]
}
